import React, { useState, useEffect } from 'react';
import Icon from '../common/Icon';

const EntryItem = ({ me, destroyME, updateME, setError }) => {
  const [editing, setEditing] = useState(false);
  const [title, setTitle] = useState(me.title);

  const toggleEdit = () => setEditing(!editing);
  const handleTitleEdit = (e) => setTitle(e.target.value);
  const handleUpdate = async (event, saveClicked = false) => {
    if (event.key === 'Enter' || saveClicked) {
      if (title == me.title || title == '') {
        setTitle(me.title);
        setEditing(false);
        setError('');
        return event.target.blur();
      }
      let ok = await updateME(event, title, me.id);
      if (ok) setEditing(false);
    }
  };

  useEffect(() => {
    if (editing) {
      document.getElementById(me.id).focus();
    }
  }, [editing]);

  return (
    <li className={'metadata-entry' + editing ? ' inline-input editing' : ''}>
      <div className='cargo'>
        <div className='name'>
          {editing ? (
            <div className='content'>
              <span>
                <input
                  type='text'
                  id={me.id}
                  value={title}
                  onChange={handleTitleEdit}
                  onKeyDown={handleUpdate}
                />
              </span>
            </div>
          ) : (
            <div className='content'>
              <span>{title}</span>
            </div>
          )}

          <div className='controls flex-controls'>
            {editing ? (
              <>
                <Icon icon='trash' onClick={(e) => destroyME(e, me.id)} />
                <Icon icon='save' onClick={(e) => handleUpdate(e, true)} />
              </>
            ) : (
              <Icon icon='pencil' onClick={toggleEdit} />
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

export default EntryItem;
